import React, {useContext, useEffect, useState} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {Breadcrumb, Button, Form, Input, notification, Select, Space, Spin, Tooltip} from "antd";

import DB_Distributor from "../../../../database/dictionary/distributors";
import DB_Branch from "../../../../database/dictionary/branch";
import {InfoCircleOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import axios from "axios";
import ModalWindow from "../../../modal";
import {Context} from "../../../../App";
import DB_PatternActivity from "../../../../database/dictionary/pattern-activity";
import DB_Warehouse from "../../../../database/dictionary/warehouse";
import Modal from "antd/es/modal/Modal";
import BackButton from "../../../tech/back_button";


const EditBranch = () => {
    const {token, setToken} = useContext(Context);
    const {getBranch, getAPItoken, createBranch, updateBranch, dependBranch, statusBranch} = DB_Branch(token);
    const {getActivePatternActivities} = DB_PatternActivity(token);
    const {getActiveDistributors} = DB_Distributor(token);
    const {createPatternActivity} = DB_PatternActivity(token);
    const {createWarehouse} = DB_Warehouse(token);
    const {t} = useTranslation();
    const params = useLocation().state;
    const {errorConnect} = ModalWindow();
    const navigate = useNavigate();
    const [isLoadSystem, setIsLoadSystem] = useState(true)
    const [wait, setWait] = useState(true);
    const [isActive, setIsActive] = useState()
    const [distributor, setDistributor] = useState([])
    const [patternActivity, setPatternActivity] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false);

    const [form] = Form.useForm();
    const [form1] = Form.useForm();


    const StatusButton = () => {
        if (params.id == null) {
            return
        }
        if (isActive) {
            return (
                <Button type={"default"} danger onClick={changeStatus}>{t('deactivate')}</Button>
            )

        } else {
            return (
                <Button type={"default"} onClick={changeStatus}>{t('activate')}</Button>
            )
        }
    }

    const changeStatus = async () => {
        setWait(true);
        if (isActive) {
            if (await dependBranch(params.id)) {
                notification.error({
                    message: t('failed'),
                    description:
                        '\n' +
                        t('e_reference', {what: t('branch').toLowerCase(), by: t('warehouse').toLowerCase()}),
                    placement: 'top'
                });
                setWait(false);
                return
            }
        } else {
            if (!checkActiveDistributor(form.getFieldValue('distributor_id'))) {
                openNotificationFailedActive(t('change_status'), t('distributor').toLowerCase())
                setWait(false);
                return
            }
        }


        const formData = new FormData;
        formData.append('id', params.id)
        formData.append('status', (isActive ? 0 : 1))

        statusBranch(formData)
            .then(res => {
                if (res.status === 200) {
                    setIsActive(!isActive);
                    setWait(false);
                } else {
                    errorConnect()
                }
            })
            .catch((e) => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            });
    }

    const generateAPIkey = async () => {
        const formData = new FormData
        formData.append('id', params.id)
        getAPItoken(formData)
            .then(res => {
                form.setFieldsValue({
                    api_token: res.data['token'].toUpperCase()
                })
            })

    }

    const checkActiveDistributor = (distributor_id) => {
        let active = true;
        distributor.map(dstr => {
                if (dstr.id === distributor_id && dstr.status === 0) {
                    active = false;
                }
            }
        )
        return active;
    }

    useEffect(() => {
        if (!isLoadSystem) {
            if (params.id != null) {
                getBranch(params.id)
                    .then(res => {
                        setIsActive(res.data['status']);

                        if (res.data['distributor_id'][0]['status'] === 0) {
                            res.data['distributor_id'].map(dstr => {
                                setDistributor(current => [...current, dstr]);
                            })
                        }

                        res.data['pattern_activity_id'].map(p => {
                            if (p.status === 0) {
                                setPatternActivity(current => [...current, p])
                            }
                        })

                        var api_key = null
                        if (res.data['api_key'] != null) {
                            api_key = res.data['api_key'].toUpperCase()
                        }
                        form.setFieldsValue({
                            name: res.data['name'],
                            distributor_id: res.data['distributor_id'][0]['id'],
                            pattern_activity_id: res.data['pattern_activity_id'].map(p => p.id),
                            api_token: api_key
                        })
                        setWait(false);
                    })
                    .catch((e) => {
                        if (e.request.status === 403) {
                            setToken(null)
                        } else {
                            setWait(false)
                            errorConnect()
                        }
                    });
            } else {
                setWait(false);
            }
        }
    }, [isLoadSystem])

    useEffect(() => {
       getDictionary()
    }, [])

    const getDictionary = (first = true) => {
        axios.all([getActiveDistributors(), getActivePatternActivities()])
            .then(axios.spread((distributors, pattern) => {
                setDistributor(distributors.data);
                setPatternActivity(pattern.data)
                setIsLoadSystem(false);
                if (!first) {
                    setIsModalVisible(false);
                    setWait(false)
                }
            }))
            .catch((e) => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            });
    }



    const createNewWarehouse = (branch_id) => {
        const formData = new FormData();
        formData.append('name', form.getFieldValue('name'))
        formData.append('name_short', form.getFieldValue('name'))
        formData.append('branch_id', branch_id)
        formData.append('automation', 1)

        axios.all([createWarehouse(formData)])
            .then(axios.spread(( w) => {
                if (w.status === 200) {
                    // navigate("/sales-structure/branches", {replace: true});
                    navigate(-1)
                } else {
                    setWait(false);
                    errorConnect();
                }
            }))
    }

    const onFinish = async (values) => {
        setWait(true);

        if (!checkActiveDistributor(values['distributor_id'])) {
            openNotificationFailedActive(t('save').toLowerCase(), t('distributor').toLowerCase())
            setWait(false);
            return
        }

        const formData = new FormData();
        formData.append('name', values["name"])
        formData.append('distributor_id', values['distributor_id'])
        formData.append('pattern_activity_id', values['pattern_activity_id'])
        if (values['api_token'] != null && !values['api_token'].includes('*')) {
            formData.append('api_key', values['api_token'])
        }
        if (params.id != null) {
            formData.append('id', params.id)
        }


        if (params.id == null) {
            createBranch(formData)
                .then(res => {
                    if (res.status === 200) {
                        Modal.confirm({
                            title: t('create_new_warehouse'),
                            onOk() {
                                createNewWarehouse(res.data['branch_id'])
                            },
                            onCancel() {
                                // navigate("/sales-structure/branches", {replace: true});
                                navigate(-1)
                            }
                        });
                    } else {
                        openNotificationFailed(t('creating'));
                    }
                })
                .catch((e) => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                });

        } else {
            updateBranch(formData)
                .then(res => {
                    if (res.status === 200) {
                        // navigate("/sales-structure/branches", {replace: true});
                        navigate(-1)
                    } else {
                        openNotificationFailed(t('updating'))
                    }
                })
                .catch((e) => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                });
        }

    }

    const openNotificationFailed = (action) => {
        notification.error({
            message: t('failed'),
            description:
                t('e_update_create', {action: action, type: t('branch').toLowerCase()}),
            placement: 'top'
        });
    };

    const openNotificationFailedActive = (type, who) => {
        notification.error({
            message: t('failed'),
            description:
                t('e_inactive', {type: type, what: t('branch').toLowerCase(), who: who}),
            placement: 'top'
        });
    };

    const createNewPatternActivity = () => {
        if (!isModalVisible) {
            setIsModalVisible(true);
        }
    }


    const ModelNewPatternActivity = () => {
        return (
            <Modal title={t('new_pattern_activity')} visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                <Form
                    form={form1}
                    autoComplete="off">

                    <Form.Item
                        name="name"
                        label={t('name')}
                        rules={[
                            {
                                required: true,
                                message: t('e_input', {input: t('name').toLowerCase()}),
                            },
                        ]}
                        hasFeedback
                    >
                        <Input/>
                    </Form.Item>
                </Form>
            </Modal>
        )
    }

    const handleOk = () => {
        if (form1.getFieldValue('name').length > 0 ) {
            setWait(true)
            const formData = new FormData();
            formData.append('name', form1.getFieldValue('name'))

            createPatternActivity(formData)
                .then(res => {
                    if (res.status === 200) {
                        getDictionary(false)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                })
                .catch(e => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                })
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            <Spin spinning={wait} delay={300}>
                <div className="page">
                    <Space
                        style={{
                            width: '100%',
                            justifyContent: 'space-between'
                        }}>
                        <Breadcrumb
                            style={{
                                margin: '15pt 0',
                            }}
                        >
                            <Breadcrumb.Item>
                                <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('branch')}</span>
                            </Breadcrumb.Item>
                        </Breadcrumb>

                        <Space>
                            <BackButton />
                            <Button shape="round" type="primary" htmlType="submit" form={"form"}>
                                {t('save')}
                            </Button>
                        </Space>
                    </Space>


                    {/*<PageHeader*/}
                    {/*    className="site-page-header"*/}
                    {/*    onBack={() =>navigate(-1)}*/}
                    {/*    title={params.id == null ? t('new_branch') : t('edit_branch')}*/}
                    {/*    // subTitle="This is a subtitle"*/}
                    {/*    breadcrumb={*/}
                    {/*        <Breadcrumb>*/}
                    {/*            <Breadcrumb.Item>*/}
                    {/*                <Link to="/site/sales-structure/branches">{t('branches')}</Link>*/}
                    {/*            </Breadcrumb.Item>*/}
                    {/*            <Breadcrumb.Item>*/}
                    {/*                {params.id == null ? t('new_branch') : t('edit_branch')}*/}
                    {/*            </Breadcrumb.Item>*/}
                    {/*        </Breadcrumb>*/}
                    {/*    }*/}
                    {/*    extra={[*/}
                    {/*        <StatusButton key="1"/>,*/}
                    {/*        <Button type={"primary"} htmlType="submit" form={"form"} key='2'>{t('save')}</Button>,*/}
                    {/*    ]}*/}
                    {/*/>*/}


                    <Form form={form}
                          style={{marginTop: '15pt'}}
                          labelCol={{
                              span: 8
                          }}
                          wrapperCol={{
                              span: 10
                          }}
                          layout={"vertical"}
                          onFinish={onFinish}
                          autoComplete="off"
                          id={"form"}
                    >
                        <Form.Item style={{marginBottom: '10pt'}}
                                   name="name"
                                   label={t('name')}
                                   rules={[
                                       {
                                           required: true,
                                           message: t('e_input', {input: t('name').toLowerCase()}),
                                       },
                                   ]}
                                   hasFeedback
                        >
                            <Input showCount maxLength={100}/>
                        </Form.Item>

                        <Form.Item
                            name="distributor_id"
                            label={t('distributor')}
                            rules={[
                                {
                                    required: true,
                                    message: t('e_select', {select: t('distributor').toLowerCase()}),
                                },
                            ]}
                            hasFeedback
                        >
                            <Select allowClear>
                                {distributor.map(distr =>
                                    <Select.Option key={distr.id} value={distr.id}
                                                   disabled={distr.status === 0}>{distr.name}</Select.Option>
                                )}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="pattern_activity_id"
                            label={t('pattern_activity')}
                            rules={[
                                {
                                    required: true,
                                    message: t('e_select', {select: t('pattern_activity').toLowerCase()}),
                                },
                            ]}
                            hasFeedback
                        >
                            <Select mode={"multiple"} allowClear>
                                {patternActivity.map(pa => {
                                        if (pa.status !== 0) {
                                            return <Select.Option key={pa.id} value={pa.id}>{t(pa.name)}</Select.Option>
                                        }
                                    }
                                )}
                            </Select>
                        </Form.Item>

                        <Form.Item style={{marginBottom: '10pt'}}>
                            <Button type={"default"} onClick={createNewPatternActivity}>{t('create_new_pattern_activity')}</Button>
                        </Form.Item>


                        <Form.Item
                            name="api_token"
                            label={t('api_token')}
                        >
                            <Input suffix={
                                <Tooltip title={t('api_token_once')}>
                                    <InfoCircleOutlined
                                        style={{
                                            color: 'rgba(0,0,0,.45)',
                                        }}
                                    />
                                </Tooltip>
                            } disabled/>
                        </Form.Item>
                        <Form.Item>
                            {params.id == null ? null : <Button onClick={generateAPIkey}>{t('generate_api_token')}</Button>}
                        </Form.Item>

                    </Form>

                    {isModalVisible ? <ModelNewPatternActivity/> : null}
                </div>
                <Outlet/>
            </Spin>

        </>
    )

}

export default EditBranch;